module.exports = __webpack_public_path__ + "img/_group_contact.41598b4a.svg";